import request from "@/global/requests/axios";
import API from "@/global/requests/api";

const courseService = {
  item(id, params = {}) {
    return request.get(API.courseItem(id), params);
  },
  postRecord(courseId, lessonId, params = {}) {
    return request.post(API.courseRecord(courseId, lessonId), params);
  },
  getRecord(courseId, lessonId) {
    return request.get(API.courseRecord(courseId, lessonId));
  },
  add(id, params) {
    return request.post(API.courseAdd(id), params);
  }
};

export default courseService;
